import React from 'react';
import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-unresolved
import './assets/scss/material-dashboard-pro-react.css?v=1.4.0';
import App from './App';


ReactDOM.render(<App />, document.getElementById('root'));
// eslint-disable-next-line no-console
console.log('version', process.env.REACT_APP_VERSION);
